import { render, staticRenderFns } from "./LotDetail.vue?vue&type=template&id=570ff47c&"
import script from "./LotDetail.vue?vue&type=script&lang=js&"
export * from "./LotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570ff47c')) {
      api.createRecord('570ff47c', component.options)
    } else {
      api.reload('570ff47c', component.options)
    }
    module.hot.accept("./LotDetail.vue?vue&type=template&id=570ff47c&", function () {
      api.rerender('570ff47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/avenants_mprinc/components/LotDetail.vue"
export default component.exports